/* Label Naveli — product page helpers: size chart, measurements, stock, save %, coupon price, tabs */
(function () {
  if (window.__nvProduct) return;
  window.__nvProduct = true;

  var CHART = [
    ['S', 36, 32, 40], ['M', 38, 34, 42], ['L', 40, 36, 44], ['XL', 42, 38, 46],
    ['2XL', 44, 40, 48], ['3XL', 46, 42, 50], ['4XL', 48, 44, 52], ['5XL', 50, 46, 54]
  ];
  var ALIAS = { XXL: '2XL', XXXL: '3XL', XXXXL: '4XL', XXXXXL: '5XL' };
  function norm(s) { s = String(s || '').trim().toUpperCase().replace(/\s+/g, ''); return ALIAS[s] || s; }
  function row(size) { var n = norm(size); for (var i = 0; i < CHART.length; i++) if (CHART[i][0] === n) return CHART[i]; return null; }
  function cm(x) { return Math.round(x * 2.54); }

  function data() {
    var el = document.querySelector('script[data-nv-pdp]');
    if (!el) return null;
    try { return el.__d || (el.__d = JSON.parse(el.textContent)); } catch (e) { return null; }
  }

  function currentVariant(d) {
    var id = null;
    var input = document.querySelector('product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]');
    if (input && input.value) id = parseInt(input.value, 10);
    if (!id) { var q = new URLSearchParams(location.search).get('variant'); if (q) id = parseInt(q, 10); }
    if (!id) id = d.selected;
    for (var i = 0; i < d.variants.length; i++) if (d.variants[i].id === id) return d.variants[i];
    return d.variants[0];
  }

  function money(cents) { return 'Rs. ' + Math.round(cents / 100).toLocaleString('en-IN'); }

  var unit = 'in';
  function renderChart(body, sel) {
    if (!body) return;
    var html = '';
    CHART.forEach(function (r) {
      var c = unit === 'cm' ? [cm(r[1]), cm(r[2]), cm(r[3])] : [r[1], r[2], r[3]];
      html += '<tr' + (sel === r[0] ? ' class="is-current"' : '') + '><td>' + r[0] + '</td><td>' + c[0] + '</td><td>' + c[1] + '</td><td>' + c[2] + '</td></tr>';
    });
    body.innerHTML = html;
  }

  function update() {
    var d = data();
    if (!d) return;
    var v = currentVariant(d);
    if (!v) return;
    var size = d.sizeIndex >= 0 ? v.options[d.sizeIndex] : null;
    var r = size ? row(size) : null;

    document.querySelectorAll('[data-nv-measure]').forEach(function (el) {
      if (!r) { el.hidden = true; return; }
      el.hidden = false;
      el.innerHTML = 'Garment (inches): Bust <b>' + r[1] + '</b> · Low waist <b>' + r[2] + '</b> · Hip <b>' + r[3] + '</b>';
    });

    document.querySelectorAll('.nv-sg').forEach(function (box) {
      var st = box.querySelector('[data-nv-stock]');
      if (st) {
        var low = parseInt(box.getAttribute('data-nv-low'), 10) || 5;
        if (v.tracked && v.available && v.qty > 0 && v.qty <= low) {
          st.hidden = false;
          st.textContent = 'Only ' + v.qty + ' left' + (size ? ' in ' + size : '') + ', order soon';
        } else { st.hidden = true; }
      }
      renderChart(box.querySelector('[data-nv-chart]'), r ? r[0] : null);
    });

    document.querySelectorAll('[data-nv-save]').forEach(function (el) {
      var pct = v.compare > v.price ? Math.round((v.compare - v.price) * 100 / v.compare) : 0;
      el.hidden = pct <= 0;
      var n = el.querySelector('[data-nv-save-pct]'); if (n) n.textContent = pct;
    });

    document.querySelectorAll('[data-nv-coupon]').forEach(function (box) {
      var p = parseFloat(box.getAttribute('data-nv-coupon')) || 0;
      var out = box.querySelector('[data-nv-coupon-price]');
      if (out && v.price > 0) out.textContent = money(v.price * (1 - p / 100));
      box.hidden = !(v.price > 0);
    });
  }

  function schedule() { update(); setTimeout(update, 80); setTimeout(update, 400); }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-nv-open]');
    if (open) {
      var dlg = document.getElementById(open.getAttribute('data-nv-open'));
      if (dlg && dlg.showModal) { update(); dlg.showModal(); }
      return;
    }
    if (e.target.closest('[data-nv-close]')) { var d1 = e.target.closest('dialog'); if (d1) d1.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('nv-sg__dialog')) { e.target.close(); return; }
    var u = e.target.closest('[data-nv-unit]');
    if (u) {
      unit = u.getAttribute('data-nv-unit');
      u.parentElement.querySelectorAll('[data-nv-unit]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === u)); });
      update();
      return;
    }
    var cp = e.target.closest('[data-nv-copy]');
    if (cp) {
      var code = cp.getAttribute('data-nv-copy');
      var done = function () { cp.textContent = 'Copied'; cp.classList.add('is-done'); setTimeout(function () { cp.textContent = 'Copy'; cp.classList.remove('is-done'); }, 1800); };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
    }
  });

  function initTabs(scope) {
    (scope || document).querySelectorAll('[data-nv-tabs]').forEach(function (wrap) {
      if (wrap.__nv) return; wrap.__nv = true;
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      var ink = wrap.querySelector('.nv-tabs__ink');
      function moveInk(t) { if (!ink || !t) return; var first = t === tabs[0]; ink.style.width = (t.offsetWidth - (first ? 12 : 24)) + 'px'; ink.style.transform = 'translateX(' + (t.offsetLeft + (first ? 0 : 12)) + 'px)'; }
      function select(t) {
        tabs.forEach(function (x) {
          var on = x === t;
          x.setAttribute('aria-selected', String(on));
          x.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(x.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        moveInk(t);
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var n = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!n) return; e.preventDefault();
          var nt = tabs[(i + n + tabs.length) % tabs.length]; nt.focus(); select(nt);
        });
      });
      requestAnimationFrame(function () { moveInk(tabs[0]); });
      window.addEventListener('resize', function () { moveInk(wrap.querySelector('[aria-selected="true"]')); });
    });
  }

  function init(scope) { initTabs(scope); schedule(); }

  document.addEventListener('change', function (e) { if (e.target.closest('variant-picker, product-form-component, form')) schedule(); }, true);
  document.addEventListener('variant:update', schedule);
  window.addEventListener('popstate', schedule);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', schedule);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
